// @mui material components
import Grid from '@mui/material/Grid';

// Material Dashboard 2 React components
import MDBox from 'components/MDBox';

// Material Dashboard 2 React example components
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from 'examples/Footer';
import ReportsBarChart from 'examples/Charts/BarCharts/ReportsBarChart';
import ComplexStatisticsCard from 'examples/Cards/StatisticsCards/ComplexStatisticsCard';

// Dashboard components

import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
  getParcSetup,
  totalBooking,
  getTruckerDetails,
  getTruckersNumberWithBooking
} from 'actions/vbs';
import { useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import i18n from 'i18next';
import { db } from '../../config/firebase';
import moment from 'moment-timezone';

const Dashboard = ({
  t,
  associatedDepot,
  bookingCounter,
  actifTruckerNumber,
  getTruckersNumberWithBooking,
  totalBooking,
  getTruckerDetails,
  managerMail,
  truckerDetails,
  companyName
}) => {
  const [bookingStatus, setBookingStatus] = useState({
    labels: [t('completed'), t('coming'), t('rejected'), t('noshow')],
    datasets: { label: ' Statut booking', data: [] }
  });
  const [parcId, setParcId] = useState(localStorage.getItem('parcId'));
  const [isAutoClosing, setIsAutoClosing] = useState(false);

  // Auto-close expired pending bookings function with debug
  const autoCloseExpiredBookings = async (currentParcId) => {
    if (!currentParcId || isAutoClosing) return;
    try {
      setIsAutoClosing(true);
      // Get yard data with timezone and VBS_Schedule
      const parcDoc = await db.collection('yards').doc(currentParcId).get();
      if (!parcDoc.exists) {
        return;
      }
      const parcData = parcDoc.data();
      const { VBS_Schedule, timezone } = parcData;
      if (!VBS_Schedule?.gate_range_duration || !timezone) {
        return;
      }
      // Get all pending bookings
      const pendingBookings = await db
        .collection('yards')
        .doc(currentParcId)
        .collection('truckerBookings')
        .where('status', '==', 'pending')
        .get();

      if (pendingBookings.empty) {
        return;
      }      
      const now = moment().tz(timezone);
      const nowValue = now.valueOf();
      
      const expiredBookings = [];
      let bookingCount = 0;
      
      // Filter expired bookings with detailed logging
      for (const doc of pendingBookings.docs) {
        bookingCount++;
        const data = doc.data();
        if (typeof data.endDate === 'number') {
          // Handle both seconds and milliseconds
          let endDateMs = data.endDate;
          let isSeconds = false;
          
          // Check if endDate is in seconds (Unix timestamp typically has 10 digits or is less than 10 billion)
          if (data.endDate.toString().length === 10 || data.endDate < 10000000000) {
            endDateMs = data.endDate * 1000;
            isSeconds = true;
          }
          
          const endDateMoment = moment.tz(endDateMs, timezone);
          const gateRangeMs = 3600 * 1000 * VBS_Schedule.gate_range_duration;
          const expiryTime = endDateMs + gateRangeMs;
          const expiryMoment = moment.tz(expiryTime, timezone);
          
       /* console.log(`endDate (${timezone}): ${endDateMoment.format('YYYY-MM-DD HH:mm:ss')}`);
          console.log(`Gate range duration: ${VBS_Schedule.gate_range_duration} hours`);
          console.log(`Expiry time (${timezone}): ${expiryMoment.format('YYYY-MM-DD HH:mm:ss')}`);
          console.log(`Expiry timestamp (ms): ${expiryTime}`);
          console.log(`Current timestamp (ms): ${nowValue}`);
          console.log(`Time difference (ms): ${expiryTime - nowValue}`);
          console.log(`Is expired (now > expiry): ${nowValue > expiryTime}`); */
          
          if (nowValue > expiryTime) {
            expiredBookings.push({
              ref: doc.ref,
              data: data,
              endDateMs: endDateMs
            });
          } else {
            const timeLeft = expiryTime - nowValue;
            const hoursLeft = timeLeft / (3600 * 1000);
            const minutesLeft = timeLeft / (60 * 1000);
          }
        }
      }
      
      if (expiredBookings.length === 0) {
        return;
      }

      // Process in batches of 500 (Firestore limit)
      const BATCH_SIZE = 500;
      let processedCount = 0;
      
      for (let i = 0; i < expiredBookings.length; i += BATCH_SIZE) {
        const batch = db.batch();
        const batchBookings = expiredBookings.slice(i, i + BATCH_SIZE);
        const dateNow = moment().tz(timezone).valueOf();

        for (const booking of batchBookings) {
          batch.update(booking.ref, {
            status: 'autoClosed',
            autoCloseDate: dateNow,
            autoClosedAt: dateNow
          });
        }

        await batch.commit();
        processedCount += batchBookings.length;
      }

      // Refresh data after auto-closing
      if (processedCount > 0) {
        // Refresh the dashboard data
        await Promise.all([
          totalBooking(currentParcId, companyName),
          getTruckersNumberWithBooking(currentParcId, companyName),
          getTruckerDetails(currentParcId, managerMail)
        ]);
      }

    } catch (error) {console.log('error',error);
    } finally {
      setIsAutoClosing(false);
    }
  };
  useEffect(() => {
    if (associatedDepot && associatedDepot.length > 0 && parcId) {
      const initializeDashboard = async () => {
        await autoCloseExpiredBookings(parcId);
        getTruckerDetails(parcId, managerMail);
        getTruckersNumberWithBooking(parcId, companyName);
        totalBooking(parcId, companyName);
      };
      initializeDashboard();
    }
  }, [associatedDepot, parcId]);

  useEffect(() => {
    if (bookingCounter && bookingCounter.length > 0) {
      // if (i18n.language === 'en') {
      setBookingStatus({
        labels: [t('completed'), t('coming'), t('rejected'), t('noshow')],
        datasets: {
          label: t('bookingStatus'),
          data: [
            bookingCounter && bookingCounter[1].acceptedCounter,
            bookingCounter && bookingCounter[1].pendingCounter,
            bookingCounter && bookingCounter[1].rejectedCounter,
            bookingCounter && bookingCounter[1].noshowCounter
          ]
        }
      });
      // }
      // if (i18n.language === 'fr') {
      //   setBookingStatus({
      //     labels: [t('completed'), t('coming'), t('rejected'), t('noshow')],
      //     datasets: {
      //       label: t('bookingStatus'),
      //       data: [
      //         bookingCounter && bookingCounter[1].acceptedCounter,
      //         bookingCounter && bookingCounter[1].pendingCounter,
      //         bookingCounter && bookingCounter[1].rejectedCounter,
      //         bookingCounter && bookingCounter[1].noshowCounter
      //       ]
      //     }
      //   });
      // }
    }
  }, [bookingCounter, i18n.language]);

 const handleDepotChange = async (e) => {
  const newParcId = e.target.value;
  setParcId(newParcId);
  localStorage.setItem('parcId', newParcId); // ← ligne manquante
  await autoCloseExpiredBookings(newParcId);
  totalBooking(newParcId, companyName);
  getTruckerDetails(newParcId, managerMail);
  getTruckersNumberWithBooking(newParcId, companyName);
};
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid pb={5} container>
        <Grid xs={4} md={4} item></Grid>
        <Grid xs={12} md={6} item>
          <FormControl fullWidth>
            <InputLabel>{t('depot')}</InputLabel>
            <Select
              value={parcId}
              label="depot"
              name={t('depot')}
              style={{ paddingBottom: '10px', textAlign: 'center', paddingTop: '10px' }}
              onChange={(e) => handleDepotChange(e)}>
              {associatedDepot &&
                associatedDepot.length > 0 &&
                associatedDepot.map((depot) => (
                  <MenuItem value={depot} key={depot}>
                    {depot}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="trending_up"
                title={t('cumulatedBookingPerYard')}
                count={
                  bookingCounter && bookingCounter.length > 0 && bookingCounter[0].counterValue
                }
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={3}>
              <ComplexStatisticsCard
                color="dark"
                icon="local_shipping"
                title={t('savedPlates')}
                count={(truckerDetails && truckerDetails.trucks?.length) || '0'}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={3}>
              <ComplexStatisticsCard
                color="dark"
                icon="schedule"
                title={t('truckerNumber')}
                count={actifTruckerNumber && actifTruckerNumber}
              />
            </MDBox>
          </Grid>
        </Grid>

        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12} alignContent="center">
              <MDBox mb={3}>
                <ReportsBarChart
                  color="info"
                  title={t('bookingCountPerStatus')}
                  chart={bookingStatus}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>

        {/* <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="store"
                title="Revenue"
                count="34k"
                percentage={{
                  color: "success",
                  amount: "+1%",
                  label: "than yesterday",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="person_add"
                title="Followers"
                count="+91"
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Just updated",
                }}
              />
            </MDBox>
          </Grid>
         */}

        {/*  <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="dark"
                  icon="weekend"
                  title="Bookings"
                  count={281}
                  percentage={{
                    color: "success",
                    amount: "+55%",
                    label: "than lask week",
                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  icon="leaderboard"
                  title="Today's Users"
                  count="2,300"
                  percentage={{
                    color: "success",
                    amount: "+3%",
                    label: "than last month",
                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="success"
                  icon="store"
                  title="Revenue"
                  count="34k"
                  percentage={{
                    color: "success",
                    amount: "+1%",
                    label: "than yesterday",
                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="primary"
                  icon="person_add"
                  title="Followers"
                  count="+91"
                  percentage={{
                    color: "success",
                    amount: "",
                    label: "Just updated",
                  }}
                />
              </MDBox>
            </Grid>
          </Grid> 
        </MDBox>*/}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};
const mapStateToProps = (state) => ({
  truckerDetails: state.vbs.truckerDetails,
  associatedDepot: state.auth.loggedUser.associatedDepot,
  bookingCounter: state.vbs.bookingCounter,
  managerMail: state.auth.loggedUser.email,
  companyName: state.auth.loggedUser.companyName,
  actifTruckerNumber: state.vbs.actifTruckerNumber
});
export default connect(mapStateToProps, {
  getParcSetup,
  totalBooking,
  getTruckerDetails,
  getTruckersNumberWithBooking
})(withTranslation()(Dashboard));
